import { useNavigate } from "@tanstack/react-router"
import type { ParseRoute } from "@tanstack/react-router"
import { useEffect } from "react"
import type { routeTree } from "routeTree.gen"

import {
  GOODS_RECEIPT_STATUS_TO_CHILD_ROUTE,
  GOODS_RECEIPT_STATUS_TO_DESKTOP_ROUTE,
  GOODS_RECEIPT_STATUS_TO_TABLET_ROUTE,
} from "../constants"

import type { GoodsReceipt, GoodsReceiptStatus } from "@/graphql/codegen/graphql"
import { useAppView } from "@/hooks/useAppView"

interface UseGoodsReceiptStatusRedirectParams {
  goodsReceipt: GoodsReceipt | null
  expectedStatus: GoodsReceiptStatus
}

export const useGoodsReceiptStatusRedirect = ({
  goodsReceipt,
  expectedStatus,
}: UseGoodsReceiptStatusRedirectParams): void => {
  const navigate = useNavigate()
  const { isTabletView } = useAppView()

  useEffect(() => {
    if (!goodsReceipt || goodsReceipt.status === expectedStatus) {
      return
    }

    const routeMap = isTabletView ? GOODS_RECEIPT_STATUS_TO_TABLET_ROUTE : GOODS_RECEIPT_STATUS_TO_DESKTOP_ROUTE
    const baseRoute = routeMap.get(goodsReceipt.status)

    if (!baseRoute) {
      return
    }

    const childRoute = GOODS_RECEIPT_STATUS_TO_CHILD_ROUTE[goodsReceipt.status] ?? ""
    navigate({
      to: `${baseRoute}/${goodsReceipt.goodsReceiptId}${childRoute}` as ParseRoute<typeof routeTree>["fullPath"],
    })
  }, [goodsReceipt, expectedStatus, isTabletView, navigate])
}
